import React, { useState } from "react";
import "../../Style/ContactForm.css";
import { ImFacebook2 } from "react-icons/im";
import { ErrorToaster } from "../../Toster";
import { ContactusApi } from "../../API/ContactUsApi";
import { NavLink } from "react-router-dom";
import { FaInstagramSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";

const ContactForm = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  const [email, setEmail] = useState("");
  const [lastName, setLastName] = useState("");
  const [subject, setSubject] = useState("");
  let emailreg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
  const [selectCountryCode, setSelctCountryCode] = useState("+61");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      name === "" ||
      lastName === "" ||
      subject === "" ||
      email === "" ||
      phone === "" ||
      subject === ""
    ) {
      ErrorToaster("All fields are required");
    } else if (emailreg.test(email) === false) {
      ErrorToaster("Valid Email");
    } else if (phone.length < 9 || phone.length > 11) {
      ErrorToaster("Numner is less than 12 and greater than 11");
    } else {
      let fromdata = {
        first_name: name,
        last_name: lastName,
        email: email,
        country_code: selectCountryCode,
        contact_number: phone,
        message: subject,
      };
      ContactusApi(fromdata);
      setEmail("");
      setName("");
      setLastName("");
      setSubject("");
      setPhone("");
    }
  };

  return (
    <>
      <div className="ContactForm">
        <div className="container-xxl p-0">
          <div className="row">
            <div className="col-lg-6">
              <h3>Stay updated be the first to know.</h3>
              <p className="mb-0">
               Many property owners may not realise that they are free to move to another real estate agency or property management team whenever they choose. Many property owners may also not realise that they are not always bound to their current agent for the full duration of a tenant’s lease. The process of changing property agencies is often simpler than expected. Di Henneberry can give you the best advice and the best professional support on your journey.
              </p>
              <p>
                For home sellers, the right price and marketing strategy can influence the outcome. If a home is intentionally quoted at a lower price, it can reduce the chances of achieving the best result. Di works with her clients and provides a considered service by developing a strategy that will utmost protect value with a great return.
              </p>
              <p> For home buyers, the best and most desirable property sells before it gets the opportunity to be listed. Di helps her clients access suitable property opportunities in the best-selling market of NSW by having educated knowledge of the best property, as well as by having and maintaining trusting professional relationships with his clients and the property agency.</p>
              <p>If you are buying, selling, leasing or even evaluating your property management arrangement, Di is excited to understand your goals so that she can help you  to achieve that in the best way.</p>
              <p>To find a diverse range of premium properties and exclusive real estate opportunities, follow Di Henneberry on LinkedIn, Facebook, and Instagram and visit often.</p>
              <div className="social-links-wrapper">
                <NavLink
                  className="social-link-icon"
                  to="https://www.facebook.com/profile.php?id=100009448066454&mibextid=LQQJ4d"
                  target="blank"
                >
                  <ImFacebook2 />
                </NavLink>
                <NavLink
                  className="social-link-icon"
                  to="https://www.instagram.com/dihenneberry/#"
                  target="blank"
                >
                  <FaInstagramSquare />
                </NavLink>
                <NavLink
                  className="social-link-icon"
                  to="https://www.linkedin.com/in/dihenneberry/"
                  target="blank"
                >
                  <FaLinkedin />
                </NavLink>
              </div>
            </div>
            <div className="col-lg-6 mt-lg-0 mt-4">
              <div className="detail_form">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6 col-sm-6">
                      <label for="your-name" className="form-label">
                        Your Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="your-name"
                        name="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <label for="your-surname" className="form-label">
                        Your Surname
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="your-surname"
                        name="lastName"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <label for="your-email" className="form-label">
                        Your Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="your-email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className=" d-flex col-3 flex-column">
                      <label for="your-name" className="form-label">
                        Code
                      </label>

                      <input
                        className="form-control"
                        value={selectCountryCode}
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "5px",
                        }}
                      ></input>
                    </div>
                    <div className="col-9">
                      <label for="your-name" className="form-label">
                        Phone
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-sm-12">
                      <label for="your-subject" className="form-label">
                        Message
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="your-subject"
                        name="your-subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit">Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
